module.exports = __webpack_public_path__ + "img/10a.176fad79.jpg";